import {
  Box,
  Section,
  SectionContent,
  SectionProps,
  SectionTitle,
} from '@wrisk/ui-components'
import React from 'react'

import { isAddOn, PolicyChangeType, Quote } from '../../../../domain'
import { useOptionalCovers } from '../../../../hooks/covers'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useProduct } from '../../../product/productContext'
import { OptionalFlexAnchor } from '../../covers'
import { AddOnCard } from './AddOnCard'

export interface AddOnSectionProps extends SectionProps {
  loading?: boolean
  quote: Quote
  onChange: (
    coverGroup: string,
    changeType: PolicyChangeType.ADD_COVER | PolicyChangeType.REMOVE_COVER,
  ) => void
}

const tKey = TKey('components.add-ons')

export const AddOnSection = ({
  loading,
  quote,
  onChange,
  ...props
}: AddOnSectionProps) => {
  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const addOns = useOptionalCovers(quote, product).filter(isAddOn(product))
  const addOnsToSelect = addOns.filter((it) => it.available && !it.active)
  const addOnsSelected = addOns.filter((it) => it.active)

  return addOnsToSelect.length || addOnsSelected.length ? (
    <Section width={1} {...props}>
      <SectionTitle>{t(tKey('header'))}</SectionTitle>
      <SectionContent>
        {Boolean(addOnsToSelect.length) &&
          addOnsToSelect.map((addOn) => (
            <AddOnCard
              coverOption={addOn}
              key={addOn.coverGroup}
              loading={loading}
              quote={quote}
              onAdd={() => onChange(addOn.coverGroup, PolicyChangeType.ADD_COVER)}
            />
          ))}

        {Boolean(addOnsSelected.length) && (
          <Box p={2} variant='raised' width={1}>
            {addOnsSelected.map((addOn) => (
              <OptionalFlexAnchor
                coverOption={addOn}
                key={addOn.coverGroup}
                loading={loading}
                quote={quote}
                onChange={() => onChange(addOn.coverGroup, PolicyChangeType.REMOVE_COVER)}
              />
            ))}
          </Box>
        )}
      </SectionContent>
    </Section>
  ) : null
}
